import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import {
  withRouterConfig,
  RouterConfigOptions,
  provideRouter,
} from "@angular/router";
import { provideDaterangepickerLocale } from "ngx-daterangepicker-bootstrap";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { httpErrorInterceptor } from "./interceptors/http-error.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        scrollPositionRestoration: "enabled",
        onSameUrlNavigation: "reload",
      } as RouterConfigOptions),
    ),
    provideDaterangepickerLocale({
      separator: " - ",
      applyLabel: "Okay",
    }),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
  ],
};
